module.exports = {"TXTWCL_Loading_cashier":{"id":"TXTWCL_Loading_cashier","defaultMessage":"キャッシャーを読み込んでいます"}}